var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7542 11.9997C14.9962 11.9997 16.003 13.0065 16.003 14.2486V14.824C16.003 15.7183 15.6835 16.5831 15.1019 17.2625C13.5326 19.096 11.1454 20.0008 8 20.0008C4.85414 20.0008 2.46812 19.0957 0.90182 17.2614C0.322059 16.5825 0.00354004 15.719 0.00354004 14.8262V14.2486C0.00354004 13.0065 1.0104 11.9997 2.25242 11.9997H13.7542ZM13.7542 13.4997H2.25242C1.83882 13.4997 1.50354 13.835 1.50354 14.2486V14.8262C1.50354 15.3619 1.69465 15.88 2.04251 16.2874C3.29582 17.755 5.26169 18.5008 8 18.5008C10.7383 18.5008 12.7059 17.755 13.9624 16.2871C14.3113 15.8795 14.503 15.3605 14.503 14.824V14.2486C14.503 13.835 14.1678 13.4997 13.7542 13.4997ZM8 0.00439453C10.7614 0.00439453 13 2.24297 13 5.00439C13 7.76582 10.7614 10.0044 8 10.0044C5.23857 10.0044 3 7.76582 3 5.00439C3 2.24297 5.23857 0.00439453 8 0.00439453ZM8 1.50439C6.067 1.50439 4.5 3.0714 4.5 5.00439C4.5 6.93739 6.067 8.50439 8 8.50439C9.93299 8.50439 11.5 6.93739 11.5 5.00439C11.5 3.0714 9.93299 1.50439 8 1.50439Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionIcon);
export default __webpack_public_path__ + "static/media/permission-icon.635a4db4f95b0554ac2118bed004be3c.svg";
export { ForwardRef as ReactComponent };